function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.1102 29C48.1102 35.1007 46.1635 40.7469 42.8572 45.3513C43.5338 49.1606 47.5876 50.7979 50.8969 51.5015C52.1309 51.7638 52.4411 53.4385 51.2515 53.8583C47.0817 55.3297 40.4227 56.6178 34.5979 53.0022C30.3528 55.5821 25.369 57.0677 20.0382 57.0677C13.8821 57.0677 8.18889 55.0865 3.56151 51.7269C8.91368 46.597 12.2374 39.3399 12.2374 31.339C12.2374 22.0214 7.72971 13.7124 0.76001 8.59738C5.7886 3.84569 12.5731 0.932251 20.0382 0.932251C35.5419 0.932251 48.1102 13.4986 48.1102 29Z",
  fill: "#FF2F3A"
});

var SvgRightDialog = function SvgRightDialog(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 58,
    viewBox: "0 0 52 58",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRightDialog, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rightDialog.b5de663d.svg";
export { ForwardRef as ReactComponent };